import type { Action } from 'react-sweet-state';
import type { SortOrderType } from '@atlaskit/dynamic-table/types';
import type { PullRequestTableOptions } from '../types';

export const setTitleFilter =
	(titleFilter: string): Action<PullRequestTableOptions> =>
	({ getState, setState }) => {
		setState({ ...getState(), titleFilter });
	};

export const setAuthorsFilter =
	(authorsFilter: string[]): Action<PullRequestTableOptions> =>
	({ getState, setState }) => {
		setState({ ...getState(), authorsFilter });
	};

export const setReviewersFilter =
	(reviewersFilter: string[]): Action<PullRequestTableOptions> =>
	({ getState, setState }) => {
		setState({ ...getState(), reviewersFilter });
	};

export const setStatusFilter =
	(statusFilter: string[]): Action<PullRequestTableOptions> =>
	({ getState, setState }) => {
		setState({ ...getState(), statusFilter });
	};

export const setRepositoryFilter =
	(repositoryFilter: string[]): Action<PullRequestTableOptions> =>
	({ getState, setState }) => {
		setState({ ...getState(), repositoryFilter });
	};

export const setSortInfo =
	(sortKey: string, sortOrder: SortOrderType): Action<PullRequestTableOptions> =>
	({ getState, setState }) => {
		setState({ ...getState(), sortKey, sortOrder });
	};

export const setPullRequestTableOptions =
	(pullRequestTableOptions: PullRequestTableOptions): Action<PullRequestTableOptions> =>
	({ setState }) =>
		setState(pullRequestTableOptions);
